import React, { useState } from 'react'
import { NavBar } from '../../../components/NavBar/NavBar'
import { AppDispatch } from 'store'

import {
  ContentWrapper,
  Flex,
  H1WithBack,
  PageWrapper,
  Tabs,
  TabsContainer,
} from '../../../styling/GlobalStyles'
import { InventoryItemsSpecificationTab } from './InventoryItemsSpecificationTab'
import { useDispatch } from 'react-redux'
import { IInventoryItem } from 'types/inventory.interface'
import { addInventoryItem, attachMSDS } from 'features/inventory/inventoryItemsSlice'
import { InventoryItemsMachineryTab } from './InventoryItemsMachineryTab'
import { useNavigate } from 'react-router-dom'
import { InventoryItemsCapabilitiesTab } from './InventoryItemsCapabilitiesTab'
import { itemsValidationList } from './itemsValidation'
import { itemInitialState } from './itemsData'
import { InventoryItemsReplenishmentTab } from './InventoryItemsReplenishmentTab'
import { InventoryItemsFinancialTab } from './InventoryItemsFinanacialTab'
import { InventoryItemsStorageTab } from './InventoryItemsStorageTab'
import { InventoryItemsTrackingTab } from './InventoryItemsTrackingTab'
import { toast } from 'react-toastify'

export const AddItem = () => {
  const [active, setActive] = useState('Specification')
  const [invalidFields, setInvalidFields] = useState(itemsValidationList)
  const [invalidCategoryFields, setInvalidCategoryFields] = useState<string[]>([])
  const dispatch = useDispatch<AppDispatch>()
  const navigate = useNavigate()
  const [state, setState] = useState<IInventoryItem>(itemInitialState) // todo. ovde je puno ali na clear je null, videti sta da se radi sa ovimwq
  const [file, setFile] = useState<File>(null)
  const handleSubmit = async () => {

    if (invalidFields.length > 0 || (state.barcodes.length && state.barcodes.some(b => !b.code || !b.type?.value || !b.unit?.value || !b.quantity))) {
      toast.warn('All required fields must be valid')
      return
    }

    const resp = await dispatch(addInventoryItem(state))
    if (resp.meta.requestStatus === 'fulfilled') {
      if (file) {
        const fileResp = await dispatch(attachMSDS({ file, id: resp.payload.id }))
        if (!(fileResp.meta.requestStatus === 'fulfilled')) {
          return
        }
      }
      navigate('/inventory/items')
    }
  }
  const renderTabs = () => {
    if (active === 'Specification') {
      return (
        <InventoryItemsSpecificationTab
          state={state}
          setState={setState}
          setActive={setActive}
          invalidFields={invalidFields}
          setInvalidFields={setInvalidFields}
          invalidCategoryFields={invalidCategoryFields}
          setInvalidCategoryFields={setInvalidCategoryFields}
        />
      )
    } else if (active === 'Machines') {
      return (
        <InventoryItemsMachineryTab
          state={state}
          setState={setState}
          setActive={setActive}
        />
      )
    } else if (active === 'Capabilities') {
      return (
        <InventoryItemsCapabilitiesTab
          state={state}
          setState={setState}
          setActive={setActive}
          handleSubmit={handleSubmit}
        />
      )
    }
    else if (active === 'Replenishment') {
      return (
        <InventoryItemsReplenishmentTab
          state={state}
          setState={setState}
          setActive={setActive}
          handleSubmit={handleSubmit}
        />
      )
    }
    else if (active === 'Financial') {
      return (
        <InventoryItemsFinancialTab
          state={state}
          setState={setState}
          setActive={setActive}
          handleSubmit={handleSubmit}
        />
      )
    }
    else if (active === 'Storage') {
      return (
        <InventoryItemsStorageTab
          state={state}
          file={file}
          setFile={setFile}
          setState={setState}
          setActive={setActive}
          handleSubmit={handleSubmit}
        />
      )
    }
    else if (active === 'Tracking') {
      return (
        <InventoryItemsTrackingTab
          state={state}
          setState={setState}
          setActive={setActive}
          handleSubmit={handleSubmit}
          invalidFields={invalidFields}
          setInvalidFields={setInvalidFields}
        />
      )
    }
  }


  return (
    <>
      <NavBar />
      <PageWrapper noFooter>
        <Flex between main>
          <H1WithBack arrow title='Add Item' />
          <TabsContainer>
            <Tabs active={active === 'Specification'} onClick={() => setActive('Specification')}>
              Specification
            </Tabs>
            <Tabs active={active === 'Replenishment'} onClick={() => setActive('Replenishment')}>
              Replenishment
            </Tabs>
            <Tabs active={active === 'Financial'} onClick={() => setActive('Financial')}>
              Financial
            </Tabs>
            <Tabs active={active === 'Storage'} onClick={() => setActive('Storage')}>
              Storage
            </Tabs>
            <Tabs active={active === 'Tracking'} onClick={() => setActive('Tracking')}>
              Tracking
            </Tabs>
            <Tabs active={active === 'Machines'} onClick={() => setActive('Machines')}>
              Machines
            </Tabs>
            <Tabs active={active === 'Capabilities'} onClick={() => setActive('Capabilities')}>
              Capabilities
            </Tabs>
          </TabsContainer>
        </Flex>
        <ContentWrapper>{renderTabs()}</ContentWrapper>
      </PageWrapper>
    </>
  )
}
